module.exports = __webpack_public_path__ + "img/plus-solid-red.ea9a6500.svg";